import { DMD_BRAND } from './alliance-tokens';
import { CURRENT_APP } from './current-app';

/**
 * Page-surface colors shared by the System Screens, the Sign In page, the
 * banners and the session dialog. Both DMD apps are light everywhere, in and
 * out of the shell (DMD App System, "DMD tokens / overrides").
 *
 * `inShell` is kept so the call sites match the Alliance components; it
 * doesn't change anything for DMD.
 */
export const pageSurface = (_params: { inShell?: boolean } = {}) => ({
  dark: false,
  bg: CURRENT_APP.background.default,
  paper: CURRENT_APP.background.paper,
  text: '#15181b',
  text2: '#00000099',
  border: '#0000001a',
  border2: '#00000038',
  hover: '#0000000a',
  /** Links and IDs: #2b5bd6 (5.9:1 on white) */
  link: DMD_BRAND.link,
  /** Logo color on light pages */
  logo: DMD_BRAND.navy,
  /** Contained buttons: navy with white text (14:1) */
  primary: DMD_BRAND.primaryButton,
  /** Title type on System Screens: size desktop / phone */
  title: {
    size: 36,
    sizeMobile: 28,
    lineHeight: 1.15,
    letterSpacing: '-.01em',
  },
});
